import { FindTargetDetailDimension } from '../../services/modules/target/target.repository.types';
import { TargetCriterionType } from '../../services/modules/target/target.types';
import {
  TARGET_AVAILABILITY_LABEL,
  TARGET_BREAKDOWN_TYPE_LABEL,
} from './object/TargetObjectPage/targetObjectLabels.constants';
import { GetCriterionValuesParams, GetDimensionNameParams } from './target.types';

export const getCriterionValues = ({
  criterion,
  translate,
}: GetCriterionValuesParams): string[] => {
  if (criterion.type !== TargetCriterionType.AVAILABILITY) {
    return criterion.references.map((reference) => reference.name);
  }

  return (criterion.availabilities ?? []).map((availability) =>
    translate(TARGET_AVAILABILITY_LABEL[availability]),
  );
};

export const getDimensionName = ({ dimension, translate }: GetDimensionNameParams): string =>
  dimension.name ?? translate(TARGET_BREAKDOWN_TYPE_LABEL[dimension.type]);

export const sortDimensions = (
  dimensions: FindTargetDetailDimension[],
): FindTargetDetailDimension[] =>
  [...dimensions].sort((first, second) => first.position - second.position);
